import classnames from 'classnames/bind';
import { Text } from '@wildberries/ui-kit';
import { memo, ReactNode, useCallback, useMemo } from 'react';
import { AttentionIcon } from '@/pages/supplies-management/_components/attention-icon';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Alert-error';

type TProps = {
  text?: string;
  title?: string;
  isFullWidth?: boolean;
  withoutMargin?: boolean;
  type?: 'error' | 'warning';
  children?: ReactNode;
  arrayText?: Array<string>;
};

type TTextErrorReason = {
  textReason: string;
  index: number;
};

export const AlertError = memo(
  ({
    title,
    text,
    isFullWidth = false,
    withoutMargin = false,
    children,
    type = 'error',
    arrayText,
  }: TProps) => {
    const color = useMemo(() => (type === 'error' ? 'red' : 'orange'), [type]);
    const textErrorReason = useCallback(
      ({ textReason, index }: TTextErrorReason) =>
        `${textReason}${index ? '.' : ''}`,
      [],
    );

    return (
      <div
        className={cn(BLOCK_NAME, {
          [`${BLOCK_NAME}--full-width`]: isFullWidth,
          [`${BLOCK_NAME}--margin`]: !withoutMargin,
          [`${BLOCK_NAME}--justify`]: Boolean(children),
          [`${BLOCK_NAME}--error`]: type === 'error',
          [`${BLOCK_NAME}--warning`]: type === 'warning',
        })}
      >
        <div className={cn(`${BLOCK_NAME}__content`)}>
          <div className={cn(`${BLOCK_NAME}__icon`)}>
            <AttentionIcon color={color} />
          </div>
          <div className={cn(`${BLOCK_NAME}__description`)}>
            <Text color="red" size="h4-bold" text={title} />
            {Boolean(text) && <Text size="h4" text={text} />}
            {Boolean(arrayText) &&
              arrayText.map((textReason, index) => (
                /** Первая строка всегда дата, точка не нужна */
                <div
                  key={`${textReason}-${index}`}
                  className={cn(`${BLOCK_NAME}__description--text`)}
                >
                  <Text
                    size="h4"
                    text={textErrorReason({ textReason, index })}
                  />
                </div>
              ))}
          </div>
        </div>
        {children}
      </div>
    );
  },
);
